import { Box } from '@mui/material';
import { Typography } from '@portals/core/src/components/Typography/Typography';
import React, { ReactElement } from 'react';

import { InternIconLink } from '../../../models';
import { Node } from '../../consumers/Consumer/Consumer';
import { useLinkProps } from '../../hooks/useLinkProps';

interface Props {
  node: InternIconLink;
  renderNode: (node: Node) => ReactElement;
}

export const AccessibilityLink: React.FunctionComponent<Props> = ({ node, renderNode }: Props) => {
  const { link, id } = node;
  const { singleProps } = useLinkProps(link && link[0]);

  return (
    <Box
      component="a"
      id={`${node.__component}.${id}`}
      {...singleProps}
      display="inline-flex"
      justifyContent="space-between"
      alignItems="center"
      gap={3}
      borderBottom={1}
      borderColor="transparent"
      color="text.primary"
      sx={{ '&:hover': { borderColor: 'text.primary' } }}
    >
      {node.icon && (
        <Box display="inline-flex" fontSize={{ xs: '18px', lg: '24px' }}>
          {renderNode(node.icon)}
        </Box>
      )}
      <Typography component="div" variant="button">
        {(link && link[0]).text}
      </Typography>
    </Box>
  );
};
